import { type FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Modal } from 'Modal';
import { Button } from 'Button';
import { Text } from 'Text';
import '../locales/streamDashboard/streamDashboard-en.json';

/*
    Confirms before a timed exam starts. An overlay click does not dismiss it; Escape does.
*/

type Props = {
    timeLimitHours: number;
    onConfirm: () => void;
    onClose: () => void;
};

export const TimeLimitModal: FC<Props> = ({ timeLimitHours, onConfirm, onClose }) => {
    const { t } = useTranslation('back_royal', { keyPrefix: 'streamDashboard.streamDashboard' });

    return (
        <Modal title={t('ready_to_begin')} onClose={onClose} size="sm" dismissOnOverlayClick={false}>
            <div className="flex flex-col items-center gap-6 px-7.5 pb-10 pt-6">
                <Text as="p" className="text-center text-md text-black">
                    {t('you_will_have_x_hours', { numHours: timeLimitHours })}
                </Text>
                <Button color="green" onPress={onConfirm}>
                    {t('start_exam')}
                </Button>
            </div>
        </Modal>
    );
};
